import { makeStyles } from '@material-ui/core/styles';

export const useViewIconStyles = makeStyles(theme => ({
  root: {
    padding: `${theme.spacing(2)}px ${theme.spacing(0)}px ${theme.spacing(1)}px ${theme.spacing(0)}px  !important`,
    '& .MuiInputLabel-outlined.MuiInputLabel-shrink': {
      backgroundColor: theme.palette.primary.light
    }
  },
  select: {
    minWidth: '8rem'
  },
  actionsContainer: {
    textAlign: 'center'
  }
}));
